var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-group-container noselect"},_vm._l((_vm.options),function(option){return _c('div',{key:option.title,staticClass:"item shadow",class:`${_vm.selected.includes(option.value) ? 'selected' : ''} ${
      option.strike_through ? 'strike_through' : ''
    } ${
      _vm.rounded ? 'circles' : ''
    }`,on:{"click":function($event){_vm.select(option.value);
      _vm.$emit('input', _vm.selected);}}},[(option.img)?_c('img',{attrs:{"src":require(`@/assets/${option.img}`),"alt":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(option.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }